// Set inventory management
// Tracks runtime state for each set (count, cost scaling, visibility)

import {
  SetInfo,
  AlphaTeamCruiser,
  Tahu,
  TheKnightBus,
  EiffelTower,
  GarbageTruck,
  HimejiCastle,
  TIEFighter,
  LloydsLegendaryDragon,
  LionKnightsCastle,
  MillenniumFalcon,
} from "../SetInfo/SetInfo";

// SetEntry extends SetInfo with runtime state
export interface SetEntry extends SetInfo {
  count: number; // Current quantity (cannot go negative)
  costScale: number; // Tracks cost scaling (increments with each purchase)
  visible: boolean; // Unlocked via gameplay (game progression)
  userHidden: boolean; // Player UI preference
}

// Initialize all sets with default values
export const SetInventory: Map<string, SetEntry> = new Map([
  [
    AlphaTeamCruiser.id,
    {
      ...AlphaTeamCruiser,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    Tahu.id,
    {
      ...Tahu,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    TheKnightBus.id,
    {
      ...TheKnightBus,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    GarbageTruck.id,
    {
      ...GarbageTruck,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    TIEFighter.id,
    {
      ...TIEFighter,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    LloydsLegendaryDragon.id,
    {
      ...LloydsLegendaryDragon,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    HimejiCastle.id,
    {
      ...HimejiCastle,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    LionKnightsCastle.id,
    {
      ...LionKnightsCastle,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    MillenniumFalcon.id,
    {
      ...MillenniumFalcon,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
  [
    EiffelTower.id,
    {
      ...EiffelTower,
      count: 0,
      costScale: 0,
      visible: false,
      userHidden: false,
    },
  ],
]);
